// extracted by mini-css-extract-plugin
export default {"itemMainContainer":"SideBarCategoryItem_itemMainContainer__mBs5Q","itemContainer":"SideBarCategoryItem_itemContainer__jzAcq","itemName":"SideBarCategoryItem_itemName__938WH"};